<template>
<div :class="{heightPc : $mq==='pc',heightSp : $mq==='sp'}">
    <!--通常投票画面-->
    <div v-if="!isAdmitQuad">
      <v-card class="ma-2" elevation="0">
        <h2 class="text-center font-weight-regular py-2" style="color: #707070; ">投票</h2>
        <h4 class="text-center font-weight-bold py-2" style="color: #2B2B2B;">
          <span v-if="vote[0]&&vote[0].isAdmitOpen=='open'">公開投票</span>
          <span v-if="vote[0]&&vote[0].isAdmitOpen=='private'">匿名投票</span>
        </h4>

        <v-card-text class="font-weight-bold px-6 py-0 text-center" v-if="vote[0]&&vote[0].isVoteEnd"><span style="color:#BA0009;" class="mr-4">投票締切</span><span v-if="vote[0]&&vote[0].voteEndAt" v-text="vote[0].voteEndAt.toDate().toLocaleString()"></span>迄</v-card-text>
        <v-card-text class="font-weight-bold pr-12 py-0 text-right" v-if="vote[0]&&vote[0].isVoteEnd">投票期間：{{getvoteend()}}</v-card-text>  

        <v-card-actions v-if="vote[0]&&vote[0].isAdmitDele===true">
          <v-card-text class="font-weight-bold pr-2">他のユーザーからの委任を受け入れる</v-card-text>
          <v-switch v-model="isPermitDele" inset></v-switch>
        </v-card-actions>
        <v-card-actions>
          <div class="mx-auto" v-if="vote[0]&&vote[0].voteType==='賛成・反対'">
            <v-btn class="agree ma-2" style="border: 3px solid;" :class="{sanseiselected: option1}" outlined fab color="#54E363" 
              x-large @click="option1=!option1">
              <p class="my-2 text-h5" style="font-weight: bold;" :class="{sanseiselected: option1}">賛成</p>
            </v-btn>
            <v-btn class="dele ma-2" :class="{ininselected: userChoice.isDoDele}" style="border: 3px solid;" outlined fab color="#008CFC"
              x-large @click="option1=false,option2=false,userChoice.isDoDele=!userChoice.isDoDele" :disabled="isPermitDele===true" v-if="vote[0].isAdmitDele===true">
              <p class="my-2 text-h5" style="font-weight: bold;" :class="{ininselected: userChoice.isDoDele}">委任</p>
            </v-btn>
            <v-btn class="against ma-2" :class="{hantaiselected: option2}" style="border: 3px solid;" outlined fab color="#E74550"
              x-large @click="option2=!option2">
              <p class="my-2 text-h5" style="font-weight: bold;" :class="{hantaiselected: option2}">反対</p>
            </v-btn>
          </div>
          <div class=""  v-if="vote[0]&&vote[0].voteType==='自由選択肢'">
            <v-btn v-if="vote[0].voteOptions[0]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option1}" 
              outlined color="#54E363" x-large @click="option1=!option1">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option1}"><span v-text="vote[0].voteOptions[0]" v-if="vote[0]"></span></p>
            </v-btn>
            <v-btn v-if="vote[0].voteOptions[1]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option2}"
              outlined color="#54E363" x-large @click="option2=!option2">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option2}"><span v-text="vote[0].voteOptions[1]" v-if="vote[0]"></span></p>
            </v-btn>
            <v-btn v-if="vote[0].voteOptions[2]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option3}"
              outlined color="#54E363" x-large @click="option3=!option3">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option3}"><span v-text="vote[0].voteOptions[2]" v-if="vote[0]"></span></p>
            </v-btn>
            <v-btn v-if="vote[0].voteOptions[3]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option4}"
              outlined color="#54E363" x-large @click="option4=!option4">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option4}"><span v-text="vote[0].voteOptions[3]" v-if="vote[0]"></span></p>
            </v-btn>
            <v-btn v-if="vote[0].voteOptions[4]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option5}" 
              outlined color="#54E363" x-large @click="option5=!option5">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option5}"><span v-text="vote[0].voteOptions[4]" v-if="vote[0]"></span></p>
            </v-btn>
            <v-btn v-if="vote[0].voteOptions[5]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option6}"
              outlined color="#54E363" x-large @click="option6=!option6">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option6}"><span v-text="vote[0].voteOptions[5]" v-if="vote[0]"></span></p>
            </v-btn>
            <v-btn v-if="vote[0].voteOptions[6]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option7}"
              outlined color="#54E363" x-large @click="option7=!option7">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option7}"><span v-text="vote[0].voteOptions[6]" v-if="vote[0]"></span></p>
            </v-btn>
            <v-btn v-if="vote[0].voteOptions[7]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option8}"
              outlined color="#54E363" x-large @click="option8=!option8">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option8}"><span v-text="vote[0].voteOptions[7]" v-if="vote[0]"></span></p>
            </v-btn>
            <v-btn v-if="vote[0].voteOptions[8]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option9}"
              outlined color="#54E363" x-large @click="option9=!option9">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option9}"><span v-text="vote[0].voteOptions[8]" v-if="vote[0]"></span></p>
            </v-btn>
            <v-btn v-if="vote[0].voteOptions[9]" class="my-2" width="100%" style="border: 3px solid; border-radius: 11px;" :class="{sanseiselected: option10}"
              outlined color="#54E363" x-large @click="option10=!option10">
              <p class="my-2 text-h6" style="font-weight: bold;" :class="{sanseiselected: option10}"><span v-text="vote[0].voteOptions[9]" v-if="vote[0]"></span></p>
            </v-btn>
            <div v-if="vote[0].isAdmitDele===true" class="d-flex justify-center">
              <v-btn class="my-2 mx-auto" :class="{ininselected: userChoice.isDoDele}" style="border: 3px solid;" outlined fab color="#008CFC"
                x-large @click="option1=false,option2=false,option3=false,option4=false,option5=false,option6=false,option7=false,option8=false,option9=false,option10=false,userChoice.isDoDele=!userChoice.isDoDele" :disabled="isPermitDele===true">
                <p class="my-2 text-h5" style="font-weight: bold;" :class="{ininselected: userChoice.isDoDele}">委任</p>
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>

        <div v-if="vote[0].isAdmitDele===true">
          <v-btn color="primary" @click="sptips5 = true" dark class="ml-8" icon outlined x-small style="background-color:white; border-width: 1px;">?</v-btn>
          ：委任について
          <v-dialog
            v-model="sptips5"
            width="auto"
          >
            <v-card>
              <v-card-text class="pt-4">
                委任投票とは自らが持つ投票権を他のLiqlid参加者へと受け渡すことができます。委任する相手を決める際には、相手のLiqlid内でのやり取りの情報などを参考にしましょう。
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>

      <v-sheet class="mx-auto pa-4" elevation="4" height="auto" width="90%" v-if="userChoice.isDoDele===true">
        <p style="color:#008CFF;" v-if="voteDelePjUserlist.length>1">委任するユーザーを選択して下さい。</p>
        <p style="color:#008CFF;" v-else>委任できるユーザーがまだいません。</p>
        <v-row>
          <v-col v-for="pj in voteDelePjUserlist" :key="pj.uid" cols="6" class="py-0">
            <v-checkbox v-if="pj.uid&&pj.isPermitDele===true" v-model="userChoice.deleTo" :label="`${namelist[pj.uid.toString()]}`" :value="`${pj.uid.toString()}`"></v-checkbox>
          </v-col>
        </v-row>
      </v-sheet>
      <div v-if="!isAuthed" class="d-flex py-4 align-center justify-center">
        <p class="mb-0" style="font-size:12px;">ログインして、投票に参加しましょう！</p>
        <v-btn class="rounded-pill px-2 ml-4" style="background-color: #008CFF" @click="authModal = true" dark>ログイン</v-btn>
      </div>
      <div v-else-if="aboutLid&&!aboutLid.sanka" class="d-flex py-4 align-center justify-center">
        <p class="mb-0" style="font-size:12px;">{{ $t('Lid') }}に参加して、投票に参加しましょう！</p>
        <v-btn class="rounded-pill px-2 ml-4" style="background-color: #008CFF" @click="LidSankaAlert = true" dark>{{ $t('Lid') }}に参加</v-btn>
      </div>
      <v-card-actions class="d-flex justify-center" v-else-if="uid!='unset'">
        <img src="../../assets/png/3010.png" width="40px" class="mr-4">
        <v-btn class="text-h6 ma-2 px-12 white--text" x-large color="#008CFF" rounded-lg @click="doVote()" >投票</v-btn>
      <!--:disabled="(!option1&&!option2&&!option3&&!option4&&!option5&&!option6&&!option7&&!option8&&!option9&&!option10&&!userChoice.deleTo)"  -->
      </v-card-actions>
    </div>
    <!--くあどら投票画面-->
    <div v-else>
      <v-card-text class="text-center text-h5 pb-0 pt-8" style="color: #707070;">クアドラティック投票</v-card-text>
      <v-card-text class="text-center text-h5" style="color: #2B2B2B;"><span v-if="vote[0]&&vote[0].isAdmitOpen=='open'">公開投票</span><span v-if="vote[0]&&vote[0].isAdmitOpen=='private'">匿名投票</span></v-card-text>

      <v-card-text class="font-weight-bold px-6 py-0 text-center" v-if="vote[0]&&vote[0].isVoteEnd"><span style="color:#BA0009;" class="mr-4">投票締切</span><span v-if="vote[0].voteEndAt" v-text="vote[0].voteEndAt.toDate().toLocaleString()"></span>迄</v-card-text>
      <v-card-text class="font-weight-bold pr-12 py-0 text-right" v-if="vote[0]&&vote[0].isVoteEnd">投票期間：{{getvoteend()}}</v-card-text>  

      <v-card-actions class="mx-2 pb-0">
        <v-card-text class="font-weight-light pb-0" style="color:#707070;">現在のあなたの投票内訳</v-card-text>
        <v-spacer></v-spacer>
        <v-card-text class="font-weight-thin text-right pb-0" style="color:#707070;">残クレジット:{{remaincre}}</v-card-text>
      </v-card-actions>
      <v-card class="mx-4" style="background-color:#DCDCDC;">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#008CFF;"><span v-text="vote[0].voteOptions[0]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(1,qn1)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn1" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(1,qn1)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <v-card class="mx-4 mt-2" style="background-color:#DCDCDC;">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#399942;"><span v-text="vote[0].voteOptions[1]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(2,qn2)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn2" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(2,qn2)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <v-card class="mx-4 my-2" style="background-color:#DCDCDC;" v-if="vote[0]&&vote[0].voteOptions[2]">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#E64550;"><span v-text="vote[0].voteOptions[2]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(3,qn3)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn3" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(3,qn3)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <v-card class="mx-4 mt-2" style="background-color:#DCDCDC;" v-if="vote[0]&&vote[0].voteOptions[3]">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#FFB336;"><span v-text="vote[0].voteOptions[3]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(4,qn4)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn4" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(4,qn4)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <v-card class="mx-4 mt-2" style="background-color:#DCDCDC;" v-if="vote[0]&&vote[0].voteOptions[4]">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#FFB336;"><span v-text="vote[0].voteOptions[4]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(5,qn5)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn5" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(5,qn5)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <v-card class="mx-4 mt-2" style="background-color:#DCDCDC;" v-if="vote[0]&&vote[0].voteOptions[5]">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#FFB336;"><span v-text="vote[0].voteOptions[5]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(6,qn6)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn6" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(6,qn6)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <v-card class="mx-4 mt-2" style="background-color:#DCDCDC;" v-if="vote[0]&&vote[0].voteOptions[6]">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#FFB336;"><span v-text="vote[0].voteOptions[6]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(7,qn7)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn7" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(7,qn7)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <v-card class="mx-4 mt-2" style="background-color:#DCDCDC;" v-if="vote[0]&&vote[0].voteOptions[7]">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#FFB336;"><span v-text="vote[0].voteOptions[7]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(8,qn8)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn8" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(8,qn8)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <v-card class="mx-4 mt-2" style="background-color:#DCDCDC;" v-if="vote[0]&&vote[0].voteOptions[8]">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#FFB336;"><span v-text="vote[0].voteOptions[8]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(9,qn9)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn9" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(9,qn9)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <v-card class="mx-4 mt-2" style="background-color:#DCDCDC;" v-if="vote[0]&&vote[0].voteOptions[9]">
        <v-card-text class="py-2 text-center font-weight-bold" style="color:#FFB336;"><span v-text="vote[0].voteOptions[9]" v-if="vote[0]"></span></v-card-text>
        <v-row class="ma-0 px-4 text-center">
          <v-spacer></v-spacer>
          <button class="px-4" v-on:click="qvminus(10,qn10)"><v-icon x-large>mdi-minus-box</v-icon></button>
          <v-text-field class="text-center" outlined style="width:3%;" v-model="qn10" :rules="crerule"></v-text-field>
          <button class="px-4" v-on:click="qvplus(10,qn10)"><v-icon x-large>mdi-plus-box</v-icon></button>
          <v-spacer></v-spacer>
        </v-row>
      </v-card>
      <div v-if="!isAuthed" class="d-flex py-4 align-center justify-center">
        <p class="mb-0" style="font-size:12px;">ログインして、投票に参加しましょう！</p>
        <v-btn class="rounded-pill px-2 ml-4" style="background-color: #008CFF" @click="authModal = true" dark>ログイン</v-btn>
      </div>
      <div v-else-if="aboutLid&&!aboutLid.sanka" class="d-flex py-4 align-center justify-center">
        <p class="mb-0" style="font-size:12px;">{{ $t('Lid') }}に参加して、投票に参加しましょう！</p>
        <v-btn class="rounded-pill px-2 ml-4" style="background-color: #008CFF" @click="LidSankaAlert = true" dark>{{ $t('Lid') }}に参加</v-btn>
      </div>
      <v-card-actions class="mx-auto" style="width:180px" v-else-if="qn1>=0 && qn2>=0 && qn3>=0 && qn4>=0 && qn5>=0 && qn6>=0 && qn7>=0 && qn8>=0 && qn9>=0 && qn10>=0 && remaincre<=qvMaxLimit">
        <v-spacer></v-spacer>
        <img src="../../assets/png/3010.png" width="50px" height="80px">
        <v-btn class="text-h4 my-auto ml-8 pt-8 pb-6" dark width="90%" x-large color="#008CFF" rounded-lg 
          @click="doVote()" :disabled="qn1<0 || qn2<0 || qn3<0 || qn4<0 || qn5<0 || qn6<0 || qn7<0 || qn8<0 || qn9 || qn10<0 || remaincre<0">投票</v-btn>
        <v-spacer></v-spacer>                   
      </v-card-actions>
    </div>
    <v-expansion-panels v-if="(vote[0]&&vote[0].isAdmitOpen=='open')||isAdmin" popout>
      <v-expansion-panel class="pb-2 px-2">
        <v-expansion-panel-header class="text-center">
          <p class="mb-0">投票状況</p>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="text-center">
            <chart :chartData="chartData3" v-if="vote[0]&&false"></chart>
            <p style="font-size:10px;">{{this.timeday}} {{this.timehour}} 現在</p>
            <p v-if="vote[0]&&vote[0].voteOptions[0]"><span v-text="vote[0].voteOptions[0]"></span>:<span v-text="this.currentVotes[0]"></span>票</p>
            <p v-if="vote[0]&&vote[0].voteOptions[1]"><span v-text="vote[0].voteOptions[1]"></span>:<span v-text="this.currentVotes[1]"></span>票</p>
            <p v-if="vote[0]&&vote[0].voteOptions[2]"><span v-text="vote[0].voteOptions[2]"></span>:<span v-text="this.currentVotes[2]"></span>票</p>
            <p v-if="vote[0]&&vote[0].voteOptions[3]"><span v-text="vote[0].voteOptions[3]"></span>:<span v-text="this.currentVotes[3]"></span>票</p>
            <p v-if="vote[0]&&vote[0].voteOptions[4]"><span v-text="vote[0].voteOptions[4]"></span>:<span v-text="this.currentVotes[4]"></span>票</p>
            <p v-if="vote[0]&&vote[0].voteOptions[5]"><span v-text="vote[0].voteOptions[5]"></span>:<span v-text="this.currentVotes[5]"></span>票</p>
            <p v-if="vote[0]&&vote[0].voteOptions[6]"><span v-text="vote[0].voteOptions[6]"></span>:<span v-text="this.currentVotes[6]"></span>票</p>
            <p v-if="vote[0]&&vote[0].voteOptions[7]"><span v-text="vote[0].voteOptions[7]"></span>:<span v-text="this.currentVotes[7]"></span>票</p>
            <p v-if="vote[0]&&vote[0].voteOptions[8]"><span v-text="vote[0].voteOptions[8]"></span>:<span v-text="this.currentVotes[8]"></span>票</p>
            <p v-if="vote[0]&&vote[0].voteOptions[9]"><span v-text="vote[0].voteOptions[9]"></span>:<span v-text="this.currentVotes[9]"></span>票</p>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>


  <!--委任確認画面-->
  <v-dialog v-model="ininwatcher" width="60%" @keydown.esc="ininwatcher = false" persistent>
    <v-card class="pa-4">
      <v-card-text class="text-center px-8 pt-2 pb-0 text-h4 font-weight-bold" style="color:#2B2B2B;">委任の受け入れを中止しますか？</v-card-text>
      <v-card-text class="text-center px-8 pb-2 text-h6" style="color:#2B2B2B;">他の人に自分の票を委任することができます。</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip class="mt-4 mx-2 px-4 font-weight-bold" color="#66baff" @click="ininwatcher=false,setdele()" dark>はい</v-chip>
        <v-chip class="mt-4 mx-2 px-4 font-weight-bold" color="#E64550" @click="isPermitDele=true" dark>いいえ</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--投票完了-->
  <v-dialog v-model="votesuccess" width="60vw">
    <v-card class="pb-4 pt-6">
      <v-card-text class="text-center px-8 py-2 font-weight-bold" style="color:#2B2B2B;" :class="$mq==='pc'?'text-h2':'text-h4'">投票完了</v-card-text>
      <v-card-text class="text-center px-8 py-2 text-h6 font-weight-bold" style="color:#707070;">投票期間内であれば内容を変更できます。</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-chip class="mx-2 px-6 text-h6" color="#66BAFF" @click="votesuccess=false,reload()" dark>確認</v-chip>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--投票締め切り通知画面-->
  <v-dialog v-model="noticeVoteend" width="60%">
    <v-card class="pt-4 pb-2">
      <v-card-text class="text-center px-8 py-2 pt-6 text-h5 font-weight-bold" style="color:#0F0101;">投票は締め切られました</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-chip class="mt-4 mx-2 px-6 font-weight-bold" color="#66BAFF" @click="noticeVoteend=false" dark>確認</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

<!--Lid参加確認画面-->
<v-dialog v-model="LidSankaAlert" width="800">
  <v-card elevation="15" class="pt-6">
    <v-card-actions class="d-flex justify-center align-center">
      <div>
        <p class="font-weight-bold text-h5 text-center">あなたはこの{{ $t('Lid') }}に参加していません。</p>
        <p class="font-weight-bold text-h5 text-center mb-0">この{{ $t('Lid') }}に参加しますか？</p>        
      </div>
    </v-card-actions>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false" >参加しない</v-chip>
      <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false, $store.dispatch('inLid',{lidId:$route.params.id,uid:uid})" color="deepAqua" dark>参加</v-chip>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-dialog>

<!--サインイン画面-->
<v-dialog v-model="authModal" width="400px" height="60%">
  <auth-view
    v-if="authModal"
    defaultView="chooseauth"
    @closeModal="closeAuthModal"
  >
  </auth-view>
</v-dialog>
</div>
</template>

<script>
import Vue from 'vue'
import firebase from "firebase/app"
import "firebase/firestore"
import chart from '../../components/chart2.vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
const authView = () => import('../../components/auth/authView.vue')
Vue.use(VueDOMPurifyHTML)
import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
export default{
  components:{
    authView,
    chart
  },
  mounted(){
    this.db = firebase.firestore() // dbインスタンスを初期化
    this.qn1 = this.qn01
    this.qn2 = this.qn02
    this.qn3 = this.qn03
    this.qn4 = this.qn04
    this.qn5 = this.qn05
    this.qn6 = this.qn06
    this.qn7 = this.qn07
    this.qn8 = this.qn08
    this.qn9 = this.qn09
    this.qn10 = this.qn010
    this.option1 = this.option01
    this.option2 = this.option02
    this.option3 = this.option03
    this.option4 = this.option04
    this.option5 = this.option05
    this.option6 = this.option06
    this.option7 = this.option07
    this.option8 = this.option08
    this.option9 = this.option09
    this.option10 = this.option010
    this.isPermitDele = this.permitdele
    this.userChoice = this.userChoice_copy
    this.today()
    this.chartData33()
  },
  props:{
    pjuid: String,
    aboutpj: Object,
    pjadmins: Array,
    voteUsers: Object,
    voteDelePjUserlist: Array,
    isPermitDeleList: Object,
    permitdele: Boolean,
    chartData: Object,
    userChoice_copy: Object,
    vote: Array,
    voteId: String,
    isAdmitDele: Boolean,
    isAdmitQuad: Boolean,
    isAdmitMulti: Boolean,
    isAdmitOpen: String,
    qn01: Number,
    qn02: Number,
    qn03: Number,
    qn04: Number,
    qn05: Number,
    qn06: Number,
    qn07: Number,
    qn08: Number,
    qn09: Number,
    qn010: Number,
    option01: Boolean,
    option02: Boolean,
    option03: Boolean,
    option04: Boolean,
    option05: Boolean,
    option06: Boolean,
    option07: Boolean,
    option08: Boolean,
    option09: Boolean,
    option010: Boolean,
    currentVotes: Array,
  },
  data: (vm) => ({
    db: null,
    offsetTop: 0,
    authModal: false,

    //dialog
    noticeVoteend: false,
    LidSankaAlert: false,

    //vote
    qvMaxLimit: 100,
    qn1: 0,
    qn2: 0,
    qn3: 0,
    qn4: 0,
    qn5: 0,
    qn6: 0,
    qn7: 0,
    qn8: 0,
    qn9: 0,
    qn10: 0,
    sum1num: 0,
    sum2num: 0,
    sum3num: 0,
    sum4num: 0,
    sum5num: 0,
    sum6num: 0,
    sum7num: 0,
    sum8num: 0,
    sum9num: 0,
    sum10num: 0,
    voteType: "賛成・反対",
    voteOptions: ["賛成","反対"],
    selectoption: ['賛成・反対','自由選択肢'],
    voteEndYYYY: '',
    voteEndMO: '',
    voteEndDD: '',
    voteEndHH: '',
    voteEndMI: '',
    options: 1,
    option1: false,
    option2: false,
    option3: false,
    option4: false,
    option5: false,
    option6: false,
    option7: false,
    option8: false,
    option9: false,
    option10: false,
    userChoice: {
      option1: 0,
      option2: 0,
      option3: 0,
      option4: 0,
      option5: 0,
      option6: 0,
      option7: 0,
      option8: 0,
      option9: 0,
      option10: 0,
      isDoDele: false,
      deleTo: ""
    },
    userChoice0: {
      option1: 0,
      option2: 0,
      option3: 0,
      option4: 0,
      option5: 0,
      option6: 0,
      option7: 0,
      option8: 0,
      option9: 0,
      option10: 0,
      isDoDele: false,
      deleTo: ""
    },
    votesuccess: false,
    ininwatcher: false,
    ininwatcherdele: false,
    //?アイコン
    sptips5: false,
    //dele
    isPermitDele: true,
    setPermitdele: true,
    //rule
    crerule: [v => v <= 10||v < 0 || '正しく入力してください'],
    //time
    timeday: "",
    timehour: "",
    chartData3: null,
    chartData2: {
      labels: ["0","1","2","3"],
      datasets: [
        {
          label: "投票結果",
          data:[5,10,15,10],
          backgroundColor: [
            '#008CFF',
            '#399942',
            '#E64550',
            '#E05922',
            '#99d1ff',
            '#6eff66',
            '#ff66ba',
            '#ffab66',
            '#993d70'
          ],
          borderColor: [
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc',
            '#dcdcdc'
          ],
          borderWidth: 1
        }
      ]
    },
  }),
  computed: {
    remaincre() { return this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)},
    namelist(){
      return this.$store.state.namelist
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    aboutLid() {
      if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
        } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
        } else {
          return null
        }
    },
  },
  watch:{
    chartData:{
      handler: function(val) {
        this.chartData33()
        console.log(val)
      }
    },
    userChoice_copy:{
      handler: function(val) {
        this.setPermitdele = true
        this.userChoice = val
      }
    },
    option01:{
      handler: function(val) {
        this.option1 = val
      }
    },
    option02:{
      handler: function(val) {
        this.option2 = val
      }
    },
    option03:{
      handler: function(val) {
        this.option3 = val
      }
    },
    option04:{
      handler: function(val) {
        this.option4 = val
      }
    },
    option05:{
      handler: function(val) {
        this.option5 = val
      }
    },
    option06:{
      handler: function(val) {
        this.option6 = val
      }
    },
    option07:{
      handler: function(val) {
        this.option7 = val
      }
    },
    option08:{
      handler: function(val) {
        this.option8 = val
      }
    },
    option09:{
      handler: function(val) {
        this.option9 = val
      }
    },
    option010:{
      handler: function(val) {
        this.option10 = val
      }
    },
    qn01:{
      handler: function(val) {
        this.qn1 = val
      }
    },
    qn02:{
      handler: function(val) {
        this.qn2 = val
      }
    },
    qn03:{
      handler: function(val) {
        this.qn3 = val
      }
    },
    qn04:{
      handler: function(val) {
        this.qn4 = val
      }
    },
    qn05:{
      handler: function(val) {
        this.qn5 = val
      }
    },
    qn06:{
      handler: function(val) {
        this.qn6 = val
      }
    },
    qn07:{
      handler: function(val) {
        this.qn7 = val
      }
    },
    qn08:{
      handler: function(val) {
        this.qn8 = val
      }
    },
    qn09:{
      handler: function(val) {
        this.qn9 = val
      }
    },
    qn010:{
      handler: function(val) {
        this.qn10 = val
      }
    },
    permitdele:{
      handler: function(val){
        this.setPermitdele = true
        this.isPermitDele = val
      }
    },
    //委任をオン/オフにした時の動作
    isPermitDele:{
      handler: function(val) {
        //デフォルトはtrue(委任の受入は許可、自分は委任できない)
          if(val===false){
            //console.log("isprefalse")
            //他者からの委任の受入を中止して自分が委任できるようにする
            if(!this.isAdmitQuad){
              if(!this.setPermitdele) this.ininwatcher = true
            }
          }
          if(val===true){
            //console.log("ispretrue")
            //他者からの委任の受入を許可して自分が委任できなくなる
            this.userChoice.isDoDele = false
            if(!this.ininwatcher){
              this.resetdele()
            }
            else{
              this.ininwatcher=false
            }
          }
          this.setPermitdele = false //これがないとpermitdeleがfalseであるときに画面読み込み時にininwatcherが出てきてしまう
      }
    },
    option1:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option2 = false
          this.option3 = false
          this.option4 = false
          this.option5 = false
          this.option6 = false
          this.option7 = false
          this.option8 = false
          this.option9 = false
          this.option10 = false
          //投票した選択肢を一時的に保存
          this.userChoice.option1 = 1 
          this.userChoice.option2 = 0
          this.userChoice.option3 = 0
          this.userChoice.option4 = 0
          this.userChoice.option5 = 0
          this.userChoice.option6 = 0
          this.userChoice.option7 = 0
          this.userChoice.option8 = 0
          this.userChoice.option9 = 0
          this.userChoice.option10 = 0
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("1に投票"+this.option1)
        }
        else if(val){
          this.userChoice.option1 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option1 = 0
      }
    },
    option2:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option1 = false
          this.option3 = false
          this.option4 = false
          this.option5 = false
          this.option6 = false
          this.option7 = false
          this.option8 = false
          this.option9 = false
          this.option10 = false
          //投票した選択肢を一時的に保存
          this.userChoice.option1 = 0
          this.userChoice.option2 = 1
          this.userChoice.option3 = 0
          this.userChoice.option4 = 0
          this.userChoice.option5 = 0
          this.userChoice.option6 = 0
          this.userChoice.option7 = 0
          this.userChoice.option8 = 0
          this.userChoice.option9 = 0
          this.userChoice.option10 = 0
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("1に投票"+this.option1)
        }
        else if(val){
          this.userChoice.option2 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option2 = 0
      }
    },
    option3:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option1 = false
          this.option2 = false
          this.option4 = false
          this.option5 = false
          this.option6 = false
          this.option7 = false
          this.option8 = false
          this.option9 = false
          this.option10 = false
          this.userChoice.option1 = 0 //投票した選択肢を一時的に保存
          this.userChoice.option2 = 0
          this.userChoice.option3 = 1
          this.userChoice.option4 = 0
          this.userChoice.option5 = 0
          this.userChoice.option6 = 0
          this.userChoice.option7 = 0
          this.userChoice.option8 = 0
          this.userChoice.option9 = 0
          this.userChoice.option10 = 0
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("1に投票"+this.option1)
        }
        else if(val){
          this.userChoice.option3 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option3 = 0
      }
    },
    option4:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option1 = false
          this.option2 = false
          this.option3 = false
          this.option5 = false
          this.option6 = false
          this.option7 = false
          this.option8 = false
          this.option9 = false
          this.option10 = false
          this.userChoice.option1 = 0 //投票した選択肢を一時的に保存
          this.userChoice.option2 = 0
          this.userChoice.option3 = 0
          this.userChoice.option4 = 1
          this.userChoice.option5 = 0
          this.userChoice.option6 = 0
          this.userChoice.option7 = 0
          this.userChoice.option8 = 0
          this.userChoice.option9 = 0
          this.userChoice.option10 = 0
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("1に投票"+this.option1)
        }
        else if(val){
          this.userChoice.option4 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option4 = 0
      }
    },
    option5:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option1 = false
          this.option2 = false
          this.option3 = false
          this.option4 = false
          this.option6 = false
          this.option7 = false
          this.option8 = false
          this.option9 = false
          this.option10 = false
          this.userChoice.option1 = 0 //投票した選択肢を一時的に保存
          this.userChoice.option2 = 0
          this.userChoice.option3 = 0
          this.userChoice.option4 = 0
          this.userChoice.option5 = 1
          this.userChoice.option6 = 0
          this.userChoice.option7 = 0
          this.userChoice.option8 = 0
          this.userChoice.option9 = 0
          this.userChoice.option10 = 0
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("1に投票"+this.option1)
        }
        else if(val){
          this.userChoice.option5 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option5 = 0
      }
    },
    option6:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option1 = false
          this.option2 = false
          this.option3 = false
          this.option5 = false
          this.option4 = false
          this.option7 = false
          this.option8 = false
          this.option9 = false
          this.option10 = false
          this.userChoice.option1 = 0 //投票した選択肢を一時的に保存
          this.userChoice.option2 = 0
          this.userChoice.option3 = 0
          this.userChoice.option4 = 0
          this.userChoice.option5 = 0
          this.userChoice.option6 = 1
          this.userChoice.option7 = 0
          this.userChoice.option8 = 0
          this.userChoice.option9 = 0
          this.userChoice.option10 = 0
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("6に投票"+this.option6)
        }
        else if(val){
          this.userChoice.option6 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option6 = 0
      }
    },
    option7:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option1 = false
          this.option2 = false
          this.option3 = false
          this.option5 = false
          this.option6 = false
          this.option4 = false
          this.option8 = false
          this.option9 = false
          this.option10 = false
          this.userChoice.option1 = 0 //投票した選択肢を一時的に保存
          this.userChoice.option2 = 0
          this.userChoice.option3 = 0
          this.userChoice.option4 = 0
          this.userChoice.option5 = 0
          this.userChoice.option6 = 0
          this.userChoice.option7 = 1
          this.userChoice.option8 = 0
          this.userChoice.option9 = 0
          this.userChoice.option10 = 0
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("7に投票"+this.option7)
        }
        else if(val){
          this.userChoice.option7 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option7 = 0
      }
    },
    option8:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option1 = false
          this.option2 = false
          this.option3 = false
          this.option5 = false
          this.option6 = false
          this.option7 = false
          this.option4 = false
          this.option9 = false
          this.option10 = false
          this.userChoice.option1 = 0 //投票した選択肢を一時的に保存
          this.userChoice.option2 = 0
          this.userChoice.option3 = 0
          this.userChoice.option4 = 0
          this.userChoice.option5 = 0
          this.userChoice.option6 = 0
          this.userChoice.option7 = 0
          this.userChoice.option8 = 1
          this.userChoice.option9 = 0
          this.userChoice.option10 = 0
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("8に投票"+this.option8)
        }
        else if(val){
          this.userChoice.option8 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option8 = 0
      }
    },
    option9:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option1 = false
          this.option2 = false
          this.option3 = false
          this.option5 = false
          this.option6 = false
          this.option7 = false
          this.option8 = false
          this.option4 = false
          this.option10 = false
          this.userChoice.option1 = 0 //投票した選択肢を一時的に保存
          this.userChoice.option2 = 0
          this.userChoice.option3 = 0
          this.userChoice.option4 = 0
          this.userChoice.option5 = 0
          this.userChoice.option6 = 0
          this.userChoice.option7 = 0
          this.userChoice.option8 = 0
          this.userChoice.option9 = 1
          this.userChoice.option10 = 0
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("9に投票"+this.option9)
        }
        else if(val){
          this.userChoice.option9 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option9 = 0
      }
    },
    option10:{
      handler: function(val) {
        if(val&&!this.vote[0].isAdmitMulti){
          this.option1 = false
          this.option2 = false
          this.option3 = false
          this.option5 = false
          this.option6 = false
          this.option7 = false
          this.option8 = false
          this.option9 = false
          this.option4 = false
          this.userChoice.option1 = 0 //投票した選択肢を一時的に保存
          this.userChoice.option2 = 0
          this.userChoice.option3 = 0
          this.userChoice.option4 = 1
          this.userChoice.option5 = 0
          this.userChoice.option6 = 0
          this.userChoice.option7 = 0
          this.userChoice.option8 = 0
          this.userChoice.option9 = 0
          this.userChoice.option10 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
          //console.log("1に投票"+this.option1)
        }
        else if(val){
          this.userChoice.option10 = 1
          this.userChoice.deleTo = null //委任先を一時的に保存
          this.userChoice.isDoDele = false
        }
        else this.userChoice.option10 = 0
      }
    },
    //クアドラの計算
    qn1:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn1 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)))
        }
      }
    },
    qn2:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn1**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn2 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn1**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)))
        }
      }
    },
    qn3:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn3 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)))
        }
      }
    },
    qn4:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn4 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)))
        }
      }
    },
    qn5:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn5 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)))
        }
      }
    },
    qn6:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn6 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn7**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)))
        }
      }
    },
    qn7:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn7 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn8**2 + this.qn9**2 + this.qn10**2)))
        }
      }
    },
    qn8:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn9**2 + this.qn10**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn8 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn9**2 + this.qn10**2)))
        }
      }
    },
    qn9:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn10**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn9 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn10**2)))
        }
      }
    },
    qn10:{
      handler: function(v, oldVal) {
        if(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2)+(oldVal*oldVal)-(v*v)<0){
          this.qn10 = Math.floor(Math.sqrt(this.qvMaxLimit-(this.qn1**2 + this.qn2**2 + this.qn3**2 + this.qn4**2 + this.qn5**2 + this.qn6**2 + this.qn7**2 + this.qn8**2 + this.qn9**2)))
        }
      }
    },
  },
  methods: {
    closeAuthModal() {
      this.authModal = false
    },
    reload(){
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },
    chartData33(){
      let it = null
      it = this.chartData
      it.datasets[0].data = [this.currentVotes[0] || 0,this.currentVotes[1] || 0,this.currentVotes[2] || 0,this.currentVotes[3] || 0,this.currentVotes[4] || 0,this.currentVotes[5] || 0,this.currentVotes[6] || 0,this.currentVotes[7] || 0,this.currentVotes[8] || 0,this.currentVotes[9] || 0]
      it.datasets[0].label = "投票状況"
      console.log(it)
      this.chartData3 = it
    },
    toDoubleDigits(num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num; 
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayy = yyyy + mm + dd + hh + mi + se + ms
      this.timeday= mm+"/"+dd
      this.timehour= hh+":"+mi
    },
    scrollBottom() { //スクロール
      //window.scrollToだと後ろの画面が動いてしまう
      this.$nextTick(() => {
        window.scrollTo(0, document.body.scrollHeight)
      })
    },
    //投票関係の関数

    //投票する
    doVote(){ //投票をする 通常投票、通常委任投票、クアドラティック投票の３種類ある
      let self = this
      //クアドラティック投票
      if(this.isAdmitQuad){
        this.userChoice.option1 = Number(this.qn1)
        this.userChoice.option2 = Number(this.qn2)
        this.userChoice.option3 = Number(this.qn3)
        this.userChoice.option4 = Number(this.qn4)
        this.userChoice.option5 = Number(this.qn5)
        this.userChoice.option6 = Number(this.qn6)
        this.userChoice.option7 = Number(this.qn7)
        this.userChoice.option8 = Number(this.qn8)
        this.userChoice.option9 = Number(this.qn9)
        this.userChoice.option10 = Number(this.qn10)
        this.userChoice.deleTo = null //委任先を一時的に保存
        this.userChoice.isDoDele = false
      }
      console.log("投票先："+JSON.stringify(this.userChoice))
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection("votes").doc(this.voteId).collection("voteusers").doc(this.uid).set({
        uid: self.uid,
        userChoice: self.userChoice, //投票先
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      },{merge:true}).then(function(docRef) {
        // 保存に成功した時
        //console.log("Votes Document written with ID: ", docRef.id)
        //console.log("投票成功")
        self.$emit('iseditpj', false)//投票画面を閉じる
        if(!self.isAdmitQuad&&self.userChoice.isDoDele&&self.userChoice.deleTo!=null){ //委任投票の場合、委任先に通知を送る
          firebase.functions().httpsCallable('notifyDele')({
            lidid: self.$route.params.id,
            pjid: self.pjuid,
            pjtitle: self.aboutpj.title,
            uid: self.uid,
            deleTo: self.userChoice.deleTo
          })
        }
        self.votesuccess=true //投票完了画面表示
      }).catch(function(error) {
        // 保存に失敗した時
        console.error("users Error adding document: ", error);
        alert("投票に失敗しました。エラー内容：:"+error)
      })
    },
    setdele(){ //他者からの委任の受入を中止して自分が委任できるようにする
      let self = this
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection("user").doc(this.uid).update({
        isPermitDele: false
      }).then(function(docRef) {
        //console.log("USERs Document written with ID: ", docRef.id)
        //console.log("setdele",false)
        firebase.functions().httpsCallable('cancellDele')({
          lidid: self.$route.params.id,
          pjid: self.pjuid,
          pjtitle: self.aboutpj.title,
          voteid: self.voteId,
          uid: self.uid,
        })
      }).catch(function(error) {
        console.error("users Error adding document: ", error)
        alert("Error!:"+error)
      })
    },
    resetdele(){ //他者からの委任の受入を許可して自分が委任できなくなる
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).collection("user").doc(this.uid).update({
        isPermitDele: true
      }).then(function(docRef) {
        //console.log("USERs Document written with ID: ", docRef.id)
      }).catch(function(error) {
        console.error("users Error adding document: ", error)
        alert("Error!:"+error)
      })
    },

    //クアドラ関係
    qvplus(p,q){
      if(this.remaincre-(2*q+1)>=0){
        if(p===1){
          this.qn1++;
        }
        else if(p===2){
          this.qn2++;
        }
        else if(p===3){
          this.qn3++;
        }
        else if(p===4){
          this.qn4++;
        }
        else if(p===5){
          this.qn5++;
        }
        else if(p===6){
          this.qn6++;
        }
        else if(p===7){
          this.qn7++;
        }
        else if(p===8){
          this.qn8++;
        }
        else if(p===9){
          this.qn9++;
        }
        else if(p===10){
          this.qn10++;
        }
      }
    },
    qvminus(p,q){
      if(q>0){
        if(p===1){
          this.qn1--;
        }
        else if(p===2){
          this.qn2--;
        }
        else if(p===3){
          this.qn3--;
        }
        else if(p===4){
          this.qn4--;
        }
        else if(p===5){
          this.qn5++;
        }
        else if(p===6){
          this.qn6--;
        }
        else if(p===7){
          this.qn7--;
        }
        else if(p===8){
          this.qn8--;
        }
        else if(p===9){
          this.qn9--;
        }
        else if(p===10){
          this.qn10--;
        }    
      }
    },
    //投票関係
    getvoteend(){ //投票期間表示用の関数
     return "投票終了するまで"
    },
    rePj(){
      this.db.collection("0").doc(this.$route.params.id).collection("project").doc(this.pjuid).update({
        condition: "dis",
      })
    },
  }
}
</script>

<style scoped>
.heightPc{
  max-height:80vh; 
  width:100%;
  overflow:hidden scroll;
}
.heightSp{
  width:100%;
  padding-top: 10px;
  overflow:hidden;
}
.dog{
  position: absolute;
  top: 20%;
  left: 5%;
}
.agree{
  width: 90px;
  height: 90px;
}
.against{
  width: 90px;
  height: 90px;
}
.sanseiselected{
  background-color: #54E363;
  color: white;
}
.ininselected{
  background-color: #008CFC;
  color: white;
}
.hantaiselected{
  background-color: #E74550;
  color: white;
}
*{
  font-family:mplus-2c-medium;
}
/*
::-webkit-scrollbar {
  display: none;
}
::-webkit-scrollbar-track {
background-color: rgba(120, 170, 210,0.3);
border-radius: 100px;
}
::-webkit-scrollbar-thumb {
background: #78aad2;
border-radius: 100px;
width: 130px;
}
*/
</style>